import { useCallback, useEffect, useState } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { BaseButton, btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

const PaymentBanner = (): JSX.Element => {
    const isLaptop = useMatchMedia(`(max-width: ${wideBreakpoints.laptop})`);
    const isTablet = useMatchMedia(`(max-width: ${wideBreakpoints.tablet})`);
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const [isShowIOSButton, setIsShowIOSButton] = useState(false);
    const [isShowAndroidButton, setIsShowAndroidButton] = useState(false);
    const [devicePlatform, setDevicePlatform] = useState('');

    const coverImgDesktop = '/static/images/payments-abn/desktop-banner.png';
    const coverImgWebpDesktop = '/static/images/payments-abn/desktop-banner.webp';

    const coverImgMobile = '/static/images/payments-abn/mobile-banner.png';
    const coverImgWebpMobile = '/static/images/payments-abn/mobile-banner.webp';

    const webpImage = isTablet ? coverImgWebpMobile : coverImgWebpDesktop;
    const pngImage = isTablet ? coverImgMobile : coverImgDesktop;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setDevicePlatform(window.navigator.platform);
        }
    }, []);

    useEffect(() => {
        if (devicePlatform && isMobile) {
            if (devicePlatform.indexOf('Mac') === 0 || devicePlatform === 'iPhone' || devicePlatform.indexOf('iPad') === 0) {
                setIsShowIOSButton(true);
            } else if (devicePlatform.indexOf('Linux') === 0 || devicePlatform.indexOf('Win32') === 0) {
                setIsShowAndroidButton(true);
            }
        } else {
            setIsShowAndroidButton(false);
            setIsShowIOSButton(false);
        }
    }, [isMobile, devicePlatform]);

    const onDataLayerPush = useCallback(() => {
        if (devicePlatform) {
            dataLayerPush({
                event: EVENTS.UAevent,
                category: CATEGORIES.newPayment,
                action: 'click on download app',
                label: `click ${devicePlatform}`,
            });
        }
    }, []);

    return (
        <ST.BannerSection>
            <WebpImage urlWebp={webpImage}>
                <ST.Image src={pngImage} alt='Изображение мобльного приложения на экране телефона' />
            </WebpImage>
            <ST.InfoBlock>
                <ST.Title>
                    Ваш Дом.ру в ваших руках
                </ST.Title>
                <ST.Subtitle>
                    Платить в приложении удобнее
                </ST.Subtitle>
                <ST.ButtonBlock>
                    {!isShowAndroidButton && (
                        <BaseButton
                            type={btnTypes.PRIMARY}
                            text={'Скачать для iOS'}
                            href={'https://app.dom.ru/ios'}
                            target='_blank'
                            onClick={() => onDataLayerPush()}
                            size={isLaptop ? btnSizes.SMALL : btnSizes.LARGE}
                        />
                    )}
                    {!isShowIOSButton && (
                        <BaseButton
                            type={btnTypes.PRIMARY}
                            text={'Скачать для Android'}
                            href={'https://app.dom.ru/android'}
                            target='_blank'
                            onClick={() => onDataLayerPush()}
                            size={isLaptop ? btnSizes.SMALL : btnSizes.LARGE}
                        />
                    )}
                </ST.ButtonBlock>
            </ST.InfoBlock>
        </ST.BannerSection>
    );
};

export default PaymentBanner;
